<template>
  <UserListCard
    v-if="permission >= 1"
    :title="$t('label.dashboardPendingAppUsers')"
    :widget="widget"
    :view-all-to="{ name: 'User' }"
    @retry="$emit('retry')"
    @page="$emit('page', $event)"
  >
    <b-table
      :items="widget.users"
      :fields="fields"
      primary-key="uuid"
      responsive
      show-empty
    >
      <template v-if="permission === 2" #cell(actions)="{ item }">
        <b-button
          variant="success"
          size="sm"
          class="mr-1"
          :disabled="busy"
          :title="$t('label.dashboardApprove')"
          :aria-label="$t('label.dashboardApprove')"
          @click="$emit('approve', item)"
        >
          <i class="mdi mdi-check" aria-hidden="true"></i>
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          :disabled="busy"
          :title="$t('label.dashboardReject')"
          :aria-label="$t('label.dashboardReject')"
          @click="$emit('reject', item)"
        >
          <i class="mdi mdi-close" aria-hidden="true"></i>
        </b-button>
      </template>
    </b-table>
  </UserListCard>
</template>
<script>
import UserListCard from "./UserListCard.vue";
export default {
  name: "DashboardPendingAppUsers",
  components: { UserListCard },
  props: {
    widget: { type: Object, required: true },
    busy: { type: Boolean, default: false },
    permission: { type: Number, default: 0 },
  },
  computed: {
    fields() {
      const fields = [
        { key: "name", label: this.$t("label.name") },
        { key: "email", label: this.$t("label.email") },
      ];
      if (this.permission === 2)
        fields.push({ key: "actions", label: this.$t("label.action") });
      return fields;
    },
  },
};
</script>
